/**
 * How a share is written as a percentage. Each formatter takes the share as a
 * fraction, so `format(0.125)` is "12.5%".
 */

const LOCALE = "en-GB";

/** With up to two decimals, and none it does not need: 12.35%, 12.5%, 50%. */
export const percentage = new Intl.NumberFormat(LOCALE, {
  style: "percent",
  maximumFractionDigits: 2,
});

/**
 * With one decimal, always: 12.4%, 50.0%. For figures that are edited or
 * listed beneath one another, which would otherwise change width.
 */
export const percentageOneDecimal = new Intl.NumberFormat(LOCALE, {
  style: "percent",
  maximumFractionDigits: 1,
  minimumFractionDigits: 1,
});

/** Rounded to a whole percent: 12%, 50%. For axis ticks and short labels. */
export const percentageNoDecimals = new Intl.NumberFormat(LOCALE, {
  style: "percent",
  maximumFractionDigits: 0,
});
